<template>
  <div class="channels_support">
    <div class="banner">
      <div class="banner_text">
        <h4>
          满分HR渠道合作计划
        </h4>
        <h6>
          满分HR致力于建立互信共赢的合作伙伴,共同打造品牌、价值、服务、与合作企业携手共进 为每一位合作伙伴创造财富与价值
        </h6>
        <div class="button" @click="contact" style="cursor:pointer;">加入满分HR渠道</div>
      </div>
    </div>
    <div class="content1">
      <h5>渠道合作优势</h5>
      <ul>
        <li>
          <img src="../../assets/img/channels_support/advantage_1.png" />
          <h6>标准化低代码产品</h6>
          <p>采用标准化低代码产品，布局SaaS生态，是国内招聘全流程管理、目标管理的专业产品服务商</p>
        </li>
        <li>
          <img src="../../assets/img/channels_support/advantage_2.png" />
          <h6>交付能力强</h6>
          <p>拥有强大的、专业的产品实施团队，针对各规模类型的客户都能够支持高效交付，帮助客户快速适应并使用产品</p>
        </li>
        <li>
          <img src="../../assets/img/channels_support/advantage_3.png" />
          <h6>持续的收入体系</h6>
          <p>客户软件续约期间内可以持续享受收入 分割更多成交线索转化支持</p>
        </li>
      </ul>
    </div>
    <div class="content2">
      <h5>渠道支持</h5>
      <ul>
        <li>
          <img src="../../assets/img/channels_support/support_1.png" />
          <div>
            <h6>培训支持</h6>
            <p>提供专业的销售打单流程，产品介绍，实施标准方法论等培训课程，加强深化您的团队全方位的能力。</p>
          </div>
        </li>
        <li>
          <img src="../../assets/img/channels_support/support_2.png" />
          <div>
            <h6>营销支持</h6>
            <p>提供专业的售前和实施支持服务，为您提供全面的商务支持。</p>
          </div>
        </li>
      </ul>
      <ul>
        <li>
          <img src="../../assets/img/channels_support/support_3.png" />
          <div>
            <h6>业务支持</h6>
            <p>客户软件续约期间内可以持续享受收入分割更多成交线索转化支持。</p>
          </div>
        </li>
        <li>
          <img src="../../assets/img/channels_support/support_4.png" />
          <div>
            <h6>激励奖励</h6>
            <p>提供低于市场的产品折扣，高于市场的利润空间。</p>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog
      :visible.sync="videoVisible"
      width="25%"
    >
    <img src="../../assets/img/contact_mf.png" style="width: 100%;"/>   
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      //默认false 弹框隐藏状态    
      videoVisible: false,
    };
  },
  mounted: function () {
    this.$store.dispatch("first_nav_change", "7");
  },
  computed: {},
  methods: {
    contact(){
      this.videoVisible = true
    }
  }
};
</script>
<style lang="scss">
.channels_support {
  .banner {
    background: url('../../assets/img/channels_support/渠道合作.jpg') center center no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .banner .banner_text {
    text-align: center;

    h4 {
      font-size: 50px;
      font-weight: 500;
      color: #ffffff;
    }

    h6 {
      font-size: 20px;
      font-weight: 400;
      color: #ffffff;
      margin-top: 30px;
      max-width: 786px;
      line-height: 32px;
    }

    .button {
      display: inline-block;
      width: 200px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      background: #007bff;
      border-radius: 4px;
      font-size: 20px;
      font-weight: 500;
      color: #ffffff;
      margin-top: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/channelsSupport.vue